module.exports = {
      id: "comm-album-usage",
      viewBox: "0 0 230.223 54.026",
      url: "/" + "sprite-80884a0dd6365dbc8eb28b3bec27c8f5.svg#comm-album",
      toString: function () {
        return this.url;
      }
    }